import AnswerPreviewContent from './answer_preview_content';
export default AnswerPreviewContent;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/answer_panel/preview/content/index.js